const resourceStrings = {
  accountReference: 'Account Reference',
  add: 'Add',
  addAlert: 'Add Alert',
  additionalTel: 'Additional Tel.',
  addNewBoltOnPackage: 'Add New Bolt-on Package',
  addSpendCap: 'Add Spend Cap',
  admin: 'Admin',
  adminBar: 'Admin Bar',
  alert: 'Alert',
  alerting: 'Alerting',
  alertLevel: 'Alert Level',
  alertMessage: 'Alert Message',
  alertMessageRequired: 'Please enter an alert message.',
  alertConfigured: 'Alert Configured',
  all: 'All',
  alphaTag: 'SMS Alpha Tag',
  alphaTagRequired: 'Please enter the SMS Alpha Tag i.e. the sender details for SMS notifications.',
  apns: 'APNs',
  applyChanges: 'Apply changes',
  arkessa: 'Arkessa',
  arkessaApn: 'Arkessa APN',
  aSessionCannotBeDeletedIfThereIsAnActiveSubmission: 'A session cannot be deleted if there is an active submission.',
  assignBoltOnsToConnections: 'Assign Bolt-Ons to Connections',
  assignConnectionsToPackage: 'Assign connections to a package.',
  assignSelectedBoltOns: 'Assign Selected Bolt-Ons',
  at: 'at',
  availableProvisioningOrders: 'Available Provisioning Orders',
  back: 'Back',
  backDate: 'Back Date',
  backDateOptional: 'Back Date (optional)',
  barServiceToggleSelectionRequired:
    'Please set all toggles to either On or Off before saving.',
  barrringAndServices: 'Barring and Services',
  barringDisabledTitle: 'Barring Disabled',
  barringDisabled: 'Barring is currently disabled. Only unbarring is allowed.',
  bookInPort: 'Book in Port',
  buildingSubmission: 'Building Submission',
  calls: 'Calls',
  cancel: 'Cancel',
  cancelSubmission: 'Cancel Submission',
  cancellingSubmission: 'Cancelling Submission',
  cap: 'Cap',
  cancelChanges: 'Cancel changes',
  changeAccount: 'Change Account',
  changeAccountRef: 'Change Account Reference',
  ChargeableCallBarO2: 'Chargeable Calls (O2 Only)',
 chargeableCalls: 'Chargeable Calls (O2 Only)',
  checkPort: 'Check Port',
  close: 'Close',
  company: 'Company',
  completed: 'Completed',
  completedSuccessfully: 'Completed Successfully',
  completedWithErrors: 'Completed with Errors',
  completeSubmission: 'Complete Submission',
  conferenceCalling: 'Conference Calling',
  conferenceCall: 'Conference Call',
  conferenceCallShort: 'Conf. Call',
  confirmAllAssignments: 'Confirm All Assignments',
  connectionDate: 'Connection Date',
  confirmPort: 'Confirm Port',
  contentControlBarShort: 'Cont. Ctrl Bar',
  continue: 'Continue',
  createBoltOnsTitle: 'Create Bolt Ons',
  crossService: 'Cross-service',
  data: 'All Data',
  dataThrottling: 'Data Throttling',
  dataBoltOnRequired: 'Please add at least one data bolt-on.',
  dcps: 'DCPs',
  defaultReconfigureSimProfileSubmissionName: 'Reconfigure SIM',
  delete: 'Delete',
  deleted: 'Deleted',
  deselectAll: 'Deselect All',
  destinationAccount: 'Destination Account',
  domesticData: 'Domestic Data',
  domesticDataBar: 'Domestic Data Bar',
  domesticVoice: 'Domestic Voice',
  domesticVoiceBar: 'Domestic Voice Bar',
  domesticVoiceShort: 'Dom. Voice',
  dualCalling: 'Call Hold',
  edit: 'Edit',
  email: 'Email',
  emailBcc: 'Email Bcc',
  emailCc: 'Email Cc',
  emailFrom: 'Email From',
  emailFromRequired: 'Please enter the sender address for email notifications.',
  emailTo: 'Email To',
  emailToRequired: 'Please enter the default email recipients.',
  enable5G: '5G',
  error: 'Error',
  errorOnSimSubmission: 'An error occurred on attempting to submit your SIM action request.',
  errors: 'Errors',
  errorLoadingProvisioningOrders: 'Could not load provisioning orders.',
  errorNoProvisioningOrdersFound: 'No permitted provisioning orders found for this account / network.',
  export: 'Export',
  exportEsim: 'Export eSim',
  filterErrorByType: 'Filter Errors By Type',
  finalised: 'Finalised',
  finaliseOrder: 'Finalise Order',
  FranceOnly: 'France Only',
  FranceRoaming: 'France Roaming',
  generationShort: 'Gen.',
  generalAlertMessage: 'Alert Message',
 gprs: 'Data',
  gprsBar: 'GPRS Bar',
 gprsDomestic: 'Domestic Data',
 gprsRoaming: 'Roamed Data',
  gprsRoamingBarShort: 'GPRS Roam Bar',
  hideFilters: 'Hide filters',
  includeCompleted: 'Include Completed',
  incomingCalls: 'Incoming Calls',
  incomingSms: 'Incoming SMS',
  internationalSms: 'International SMS',
  inProgress: 'In Progress',
  international: 'International',
  InternationalAndRoaming: 'Intl. and Roaming',
  InternationalAndRoamingBarred: 'Intl. and Roaming Barred',
  internationalBarShort: 'Int. Bar',
  internationalCalls: 'International Calls',
  internationalCallExUk: 'International Call Excluding UK',
  internationalCallsShort: 'Intl. Calls',
  InternationalOnly: 'International Only',
  internationalSlashSmsBar: 'International Calls/SMS Bar',
  intxHome: 'International Calls (ex. UK)',
  invalid_alertLevelOutOfRange: 'Alert level must be greater than zero.',
  invalid_alertMessageRequired: 'An alert message is required.',
  invalid_alertMustBeGreaterThanWarningLevel: 'Alert level must be greater than warning level.',
  invalid_capRequired: 'Cap required.',
  invalid_capMustBeGreaterThanZero: 'Please enter a value greater than zero.',
  invalid_capTooLarge: 'Please enter a valid spend cap less than 922337203685477.5807.',
  invalid_emailRequired: 'Email required.',
  invalid_smsAlertTooLong: 'Alphatag may not be greater than 11 characters long.',
  invalid_smsAlphaNotAllowedChars: 'Alpha tag has characters that are not allowed',
  invalid_telRequired: 'Tel required.',
  invalid_warningLevelOutOfRange: 'Warning level must be greater than zero and less than 100.',
  invalid_warningMustBeLessThanAlertLevel: 'Warning level must be lower than alert level.',
  invalid_warningMessageRequired: 'A warning message is required.',
  invalid: 'Invalid',
  invalidAccountReference:
    'Invalid Account Reference, must only contain alphanumeric, underscore(_) and hyphen(-) characters.',
  invalidConnectionDateNotWithinExpectedPeriod:
    'The supplied Connection Date is not within the 30 days period of the expiry date.',
  invalidPoolingNotSupported:
    'The selected tariff does not support pooling. ' + 'Please select a provisioning order which is not pooled.) ',
  invalidProvisioningOrderNotFound:
    'Please select another option' + ' - this provisioning order was not found in the list of allowed options.',
  loading: 'Loading...',
  loadingProvisioning: 'Loading provisioning...',
  loadingProvisioningOrders: 'Loading available provisioning orders...',
  loadingSubmissionDetailsSubmission: 'Loading submission details submission',
  lteCalling: 'VoLTE Calling',
  main: 'Main',
  misc: 'Misc',
  mms: 'MMS',
 premium: 'Premium Calls',
  mpayBar: 'MPAY Bar',
  field: 'mpayBar',
  name: 'Name',
  new: 'New',
  noProvisioningOrderCreateOne:
    'No suitable provisioning orders currently exist' + ' - please select the option to create one.',
  noProvisioningOrdersFound: 'No suitable provisioning orders found',
  noSIMOrdersFound: 'No SIM Orders found!',
  notStarted: 'Not Started',
  order: 'Order',
  outgoingCallBar: 'Outgoing Call Bar',
 outgoing: 'Outgoing Calls',
  outgoingCalls: 'Outgoing Calls',
  outgoingDomestic: 'Outgoing Domestic Calls',
 outgoingInternationalCalls: 'Out. Int. Calls',
  outgoingInternationalCallsShort: 'Out. Int. Calls',
  outgoingSms: 'Outgoing SMS',
  serviceNumber: 'Service Number',
  directoryEnquiry: 'Directory Enquiry',
  voiceRoamingRow: 'Voice Roaming ROW',
  smsPremiumWeb: 'SMS Premium Web',
  smsPremiumShortCode: 'SMS Premium Short Codes',
  dataRoamingRow: 'Data Roaming ROW',
  contentControl: 'Content Control',
  VisualVoicemail: 'Visual Voicemail',
  InternationalAndRoamingBar: 'International And Roaming Bar',
  RoamingBar: 'Roaming Bar',
  DataRoamingBar: 'Data Roaming Bar',
  StrictContent: 'Strict',
  ModerateContent: 'Moderate',
  pac: 'PAC',
  pacCode: 'PAC Code',
  packagesNeedDataBoltOn: 'Packages need a Data Bolt-On.',
  pending: 'Pending',
  pendingSubmission: 'Pending Submission',
  pleaseClickHereToBeginASimOrder: 'Please click here to begin a SIM Order.',
  pleaseEnterAccountReference: 'Please enter an account reference.',
  pleaseSelect: 'Please select...',
  pleaseSelectADestinationAccount: 'Please select a destination account.',
  pleaseSelectProvisioningOrder: 'Please select a provisioning order.',
  pleaseSpecifyName: 'Please specify a name.',
  poolingWarning: 'The selected tariff does not support pooling - only non-pooled provisioning orders are allowed.',
  premiumBar: 'Premium Bar',
  premiumCalls: 'Premium Calls',
  premiumRate: 'Premium Rate',
  premiumSlashSmsBar: 'Premium Rate Calls/SMS Bar',
  premiumSms: 'Premium SMS',
  previousAccountReferences: 'Previous Account References',
  processing: 'Processing',
  provisioningOrder: 'Provisioning Order',
  provisioningOrderContainsInvalidCharacters: 'Provisioning order name may not contain "*" or "pooled".',
  provisioningOrderWillBePooled: 'This provisioning order will be pooled.',
  provisioningOrderWillNotBePooled: 'This provisioning order will not be pooled.',
  provisionOrderCannotBeSamename: 'A new provision order cannot have the same name as an existing provision order',
  provisionType: 'Provision Type',
  puk: 'PUK',
  purchaseOrderNumber: 'Purchase Order Number',
  quarantine: 'Quarantine',
  matchingValues: 'matching values',
  migratedInSimType: 'Migrate-in SIM Type',
  mobileNumber: 'Mobile Number',
  multipleStatuses: 'Multiple Statuses',
  notSet: 'Not set',
  notifyEmail: 'Notify Email',
  readyToSubmit: 'Ready to Submit',
  refresh: 'Refresh',
  removeBoltOnPackageWarning: 'To remove the Bolt-on package, please unassign the connections assigned.',
  reset: 'Reset',
  roamedData: 'Roamed Data',
  roamedDataBar: 'Roamed Data Bar',
  roamedVoice: 'Roamed Voice',
  roamedVoiceBar: 'Roamed Voice Bar',
  roaming: 'Roaming',
  roamingIncomingCalls: 'Roaming Incoming Calls',
  roamingOutgoingCalls: 'Roaming Out. Calls',
  roamingOutgoingInternationalCalls: 'Roaming Out. Int. Calls',
  reverse: 'Reverse',
  save: 'Save',
  selected: 'Selected',
  selectMany: 'Select',
  serial: 'Serial',
  serialNumber: 'Serial Number',
  showCompletedSimOrders: 'Show Completed SIM Orders',
  showFilters: 'Show filters',
  showing: 'Showing',
  simAttributes: 'Sim Attributes',
  sms: 'All SMS',
  smsAlphaTag: 'SMS Alphatag',
 smsIncoming: 'Incoming SMS',
 smsOutgoing: 'Outgoing SMS',
 smsPremium: 'Premium SMS',
  smsIncomingBarShort: 'SMS In Bar',
  smsOptOut: 'SMS Opt-out',
  smsOutgoingBarShort: 'SMS Out Bar',
  smsPremiumBar: 'SMS Premium Bar',
  someFeaturesDisabledWarning: 'Some features such as unbarring are disabled. Please contact support.',
  sourceNetwork: 'Source Network',
  specifyAllTels: 'Please ensure that all telephone numbers are specified.',
  specifyTheAccountWhereYouWishToMoveTheSelectedSims:
    'Specify the account where ' + 'you wish to move the selected SIMs.',
  specifyTheAccountReference:
    'Specify the account reference in the box below. ' +
    'If an existing account reference is found it will be shown in a drop down directly below the box.',
  spendCap: 'Spend Cap',
  spendCapConfigured: 'Spend Cap Configured',
  spendCaps: 'Spend Caps',
  standardBoltOns: 'Standard Bolt-Ons',
  status: 'Status',
  step4Narrative:
    'Work through each tariff/provisioning order and create the bolt-on combinations you' +
    ' will require for provisioning in the left hand box.Then assign to the connections.',
  step4Title: 'Create and Assign Bolt-Ons',
  submit: 'Submit',
  submitChanges: 'Submit Changes',
  submitPort: 'Submit Port',
  submitted: 'Submitted',
  subscriberNo: 'Subscriber No',
  targetNetwork: 'Target Network',
  tariff: 'Tariff',
  tariffRequired: 'Please select a tariff.',
  tel: 'Tel',
  telsMustBeUnique: 'Please ensure that all telephone numbers are unique.',
  temporalBoltOns: 'Temporal Bolt-Ons',
  thereAreNoAvailableAccountsToMoveTheSpecifedSims: 'There are no available accounts to move the specifed SIMs.',
  Throttle250MB: '250MB',
  Throttle500MB: '500MB',
  Throttle1GB: '1GB',
  Throttle2GB: '2GB',
  Throttle3GB: '3GB',
  Throttle4GB: '4GB',
  Throttle5GB: '5GB',
  Throttle10GB: '10GB',
  Throttle20GB: '20GB',
  Throttle30GB: '30GB',
  Throttle40GB: '40GB',
  Throttle50GB: '50GB',
  Throttle100GB: '100GB',
  Throttle200GB: '200GB',
  Throttle300GB: '300GB',
  Throttle500GB: '500GB',
  totalCount: 'Total Count',
  triggeredSpendCaps: 'Triggered Spend Caps',
  unselected: 'Unselected',
  update: 'Update',
  updated: 'Updated',
  updateAllConnectionDates: 'Update All Connection Dates',
  updateAllPacCodes: 'Update All PAC Codes',
  updatedBy: 'Updated by',
  upload: 'Upload',
  undoDeletion: 'Undo Deletion',
  usage: 'usage',
  validate: 'Validate',
  validated: 'Validated',
  validating: 'Validating',
  voice: 'Voice',
  voicemail: 'Voicemail',
  visualVoicemail: 'Visual Voicemail',
  voiceRoaming: 'Voice Roaming',
  voiceRoamingBarShort: 'Voice Roam Bar',
  warning: 'Warning',
  warningLevel: 'Warning Level',
  warningMessage: 'Warning Message',
  warningMessageRequired: 'Please enter a warning message.',
  wifiCalling: 'WiFi Calling',
  wifiCallingShort: 'WiFi Call',
  yourRef: 'Your Ref',
  unassignSelectedBoltOns: 'Unassign Selected Bolt-Ons',
  templateName: 'Template Name',
  outgoingInternationalCallsBar: 'Outgoing International Calls Bar',
  premiumCallsBar: 'Premium Calls Bar',
  incomingCallsBar: 'Incoming Calls Bar',
  roamingOutgoingInternationalCallsBar: 'Roaming Outgoing International Calls Bar',
  roamingBar: 'Roaming Bar',
  roamingIncomingCallsBar: 'Roaming Incoming Calls Bar',
  roamingOutgoingCallsBar: 'Roaming Outgoing Calls Bar',
  InternationalCalls: 'International Calls',
  OutgoingInternationalCalls: 'Out. International Calls',
  AllBarred: 'All Barred',
  OutgoingBarredOnly: 'Outgoing Barred Only',
  Enabled: 'Enabled',

  // GraphicalDashboard
  ActiveSimsByNetwork: 'Provisioned SIMs By Network',
  BundlesAndOverage: 'Bundles and Overage',
  ProvisionedSimsByNetwork: 'Provisioned SIMs by Network',
  SimsByNetwork: 'SIMs by Network',
  SimsByStatus: 'SIMs by legacy Status',
  ActiveBundles: 'Bundles and Overage',
  HighestData: 'Highest Data Usage SIMs',
  HighestOverage: 'Highest Data Overage SIMs',
  InBundle: 'In Bundle',
  InOverage: 'In Overage'
};

export default resourceStrings;
